import { render, staticRenderFns } from "./CandidatesRefreshButton.vue?vue&type=template&id=a4a6970c&scoped=true&lang=pug"
import script from "./CandidatesRefreshButton.vue?vue&type=script&lang=js"
export * from "./CandidatesRefreshButton.vue?vue&type=script&lang=js"
import style0 from "./CandidatesRefreshButton.vue?vue&type=style&index=0&id=a4a6970c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a6970c",
  null
  
)

export default component.exports